/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:57
 * @LastEditTime: 2024-02-05 20:11:18
 * @FilePath: \yl-cjsph-tms-operation-front\src\utils\auth.ts
 * @Description:
 */
import Cookies from 'js-cookie';
import md5 from 'js-md5';
import { ACCOUNT_INFO_NAMES } from '@/utils/const';
// import { storageSession } from '@pureadmin/utils';
export interface DataInfo<T> {
  /** token */
  accessToken: string;
  /** `accessToken`的过期时间（时间戳） */
  expires: T;
  /** 用于调用刷新accessToken的接口时所需的token */
  refreshToken: string;
  /** 用户名 */
  username?: string;
  /** 当前登陆用户的角色 */
  roles?: Array<string>;
}

const TokenKey = ACCOUNT_INFO_NAMES['token'];
const cjs_username = ACCOUNT_INFO_NAMES['username'];
const cjs_password = ACCOUNT_INFO_NAMES['password'];

/** 获取`token` */
export function getToken(): string {
  // 此处与`TokenKey`相同，此写法解决初始化时`Cookies`中不存在`TokenKey`报错
  return Cookies.get(TokenKey) || '';
}

/**
 * @description 设置`token`以及一些必要信息并采用无感刷新`token`方案
 * 无感刷新：后端返回`accessToken`（访问接口使用的`token`）、`refreshToken`（用于调用刷新`accessToken`的接口时所需的`token`，`refreshToken`的过期时间（比如30天）应大于`accessToken`的过期时间（比如2小时））、`expires`（`accessToken`的过期时间）
 * 将`accessToken`、`expires`这两条信息放在key值为authorized-token的cookie里（过期自动销毁）
 * 将`username`、`roles`、`refreshToken`、`expires`这四条信息放在key值为`user-info`的sessionStorage里（浏览器关闭自动销毁）
 */
export function setToken(accessToken: string, data: any) {
  Cookies.set(TokenKey, accessToken, { expires: 7 });
  if (data.remember) {
    if (Cookies.get(cjs_password) === data.password) return;
    Cookies.set(cjs_username, data.username, { expires: 7 });
    Cookies.set(cjs_password, md5(data.password), { expires: 7 });
  } else {
    // Cookies.set(cjs_username, '');
    // Cookies.set(cjs_password, '');
  }
}

/** 删除`token`以及key值为`user-info`的session信息 */
export function removeToken() {
  Cookies.remove(TokenKey);
  sessionStorage.clear();
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token;
};
